import { render, staticRenderFns } from "./DateCoachPage.vue?vue&type=template&id=28f94922&scoped=true"
import script from "./DateCoachPage.vue?vue&type=script&lang=js"
export * from "./DateCoachPage.vue?vue&type=script&lang=js"
import style0 from "./DateCoachPage.vue?vue&type=style&index=0&id=28f94922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f94922",
  null
  
)

export default component.exports